module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-5.99691e54.jpg";